import React, { useState } from "react";
import close from "../../../../static/ic-close.svg";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import { OpenCloseMessageBox } from "../../../../Redux/actions/actionNames";

class App extends React.Component {
  constructor(props){
    super(props);

    this.openCloseTransaction = this.openCloseTransaction.bind(this)
  }

  openCloseTransaction= () => {
    this.props.dispatch(OpenCloseMessageBox(false));
  }

  render() {
    return (
      <div className="OrderListHeader">
        <img onClick={this.openCloseTransaction} src={close} className="OrderListHeaderClose" />
        <span className="OrderListHeaderTitle" onClick={this.openCloseTransaction}>
          <Trans i18nKey={"MessageBox"}>
          </Trans>
        </span>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
